import { atom } from "recoil";

interface SelectedMarkerType {
  name: string;
  id: number;
}

export const selectMapMarkerState = atom<SelectedMarkerType>({
  key: "selectMapMarker",
  default: {
    name: "",
    id: 0,
  },
});

interface Coords {
  lat: number;
  lng: number;
}
export const worldMapCenterState = atom<Coords>({
  key: "worldMapCenter",
  default: {
    lat: 37.41,
    lng: 127.26,
  },
});

export const alreadyAlarmCompletedState = atom<boolean>({
  key: "alreadyAlarmCompleted",
  default: false,
});
